<template>
  <div class="ma-4">
    <ProgramNav :programID="$route.params.programID || $route.params.employeeID" />
    <div class="ma-2 mt-10">
      <form-dialog
        ref="form-dialog"
        :title="title"
        @save-item="save"
        @update-item="update"
      />
      <div class="ma-1">
        <v-alert
          dense
          border="top"
          colored-border
          type="info"
          color="primary"
          elevation="2"
        >
          <span class="bm-info">
            <v-row align="center" no-gutters>
              <strong>Documenting the Water Temperature</strong> <br />
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <v-btn
                  color="primary"
                  outlined
                  x-small
                  @click="showInfo1 = !showInfo1"
                >
                  {{ showInfo1 ? "hide" : "show" }}
                </v-btn>
              </v-col>
            </v-row>
            <v-expand-transition>
              <div v-if="showInfo1" class="text-body-2">
                <p>
                  Record temperatures in Fahrenheit (°F), and initial in the
                  same box below the recorded entry.
                  <br />
                  For all locations, the temperatures are to be recorded daily
                  at 6:00am. The water must run for three (3) minutes at each
                  location prior to measuring and recording the temperature.
                </p>
              </div>
            </v-expand-transition>
          </span>
        </v-alert>

        <v-alert
          dense
          border="top"
          colored-border
          type="info"
          color="primary"
          elevation="2"
        >
          <span class="bm-info">
            <v-row align="center" no-gutters>
              <strong>Target Temperatures</strong> <br />
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <v-btn
                  color="primary"
                  outlined
                  x-small
                  @click="showInfo2 = !showInfo2"
                >
                  {{ showInfo2 ? "hide" : "show" }}
                </v-btn>
              </v-col>
            </v-row>
            <v-expand-transition>
              <div v-if="showInfo2" class="text-body-2">
                <div>Refrigerator: 40-32 °F</div>
                <div>Freezer: 0 °F or below</div>
                <div>Sink Faucets: Between 114-119 °F</div>
              </div>
            </v-expand-transition>
          </span>
        </v-alert>
      </div>

      <v-card class="pa-0 mb-3" outlined flat>
        <v-card-actions>
          <v-btn-toggle>
            <v-btn @click="togglePage('list')">
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
            <v-btn @click="togglePage('chart')">
              <v-icon>mdi-card-text-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            :loading="isDownloading"
            :disable="isDownloading"
            @click="generateReport"
          >
            download report
            <template v-slot:loader>
              <span>generating...</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>

      <div class="tscroll" v-if="page === 'chart'">
        <table>
          <thead class="table-head">
            <tr>
              <th class="table-head-th"></th>
              <th
                class="table-head-th"
                v-for="(date, i) in chart.dates"
                :key="i"
              >
                {{ i + 1 }}
              </th>
            </tr>
          </thead>
          <tbody class="main-body">
            <template>
              <tr v-for="row in chart.items" :key="row.date">
                <td class="main-body--schedule">
                  <div class="main-body-td--content-schedule text-center">
                    {{ row.location }}
                  </div>
                </td>
                <td
                  class="main-body--info"
                  v-for="cell in row.charts"
                  :key="cell.id"
                  :bgcolor="
                    userId === cell.records.staffId
                      ? 'green'
                      : userId !== cell.records.staffId &&
                        cell.records.temperature === ''
                      ? ''
                      : 'gray'
                  "
                  @click="selectCell(row, cell)"
                >
                  <div class="main-body-td--content text-center">
                    <span v-if="cell.records.temperature != ''">
                      <span class="white--text text-subtitle-2"
                        >{{ cell.records.temperature }}
                        <span class="font-size: 5px;">°F</span></span
                      >
                      <br />
                      <span class="text-caption white--text">{{
                        cell.records.staff
                      }}</span>
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div v-else>
        <ChartList @fetch-chart-data="fetch" />
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import FormDialog from "../chart/FormDialog";
import ProgramNav from "@/components/ProgramNav";
import ChartList from "./ChartList";
import download from "downloadjs";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ProgramNav,
    ChartList,
    FormDialog,
  },
  data() {
    return {
      selectedCell: null,
      dialog: true,
      staffId: "",
      isLoading: false,
      location: "",
      scheduledDate: "",
      selectedItemId: "",
      showInfo1: true,
      showInfo2: true,
      userId: "",
      page: "chart",
      title: "Add Temperature",
      isDownloading: false
    };
  },

  computed: {
    ...mapGetters("waterTemperatureItems", ["chart"]),

    showBMInfo() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.showInfo1 = false;
        this.showInfo2 = false;
      } else {
        this.showInfo1 = true;
        this.showInfo2 = true;
      }
    },
  },

  watch: {
    showBMInfo(val) {
      return val;
    },
  },

  created() {
    this.fetch();
    this.userId = localStorage.getItem("userID");

    if (this.$route.query.id === undefined) {
      this.$router.back();
    }
  },
  watch: {
    '$route.query.id'() {
      this.fetch();
    },
    '$route.params.employeeID'() {
      this.fetch();
    },
    '$route.params.programID'() {
      this.fetch();
    }
  },
  methods: {
    ...mapActions({
      getChartItems: "waterTemperatureItems/getChartItems",
      createItem: "waterTemperatureItems/createItem",
      updateItem: "waterTemperatureItems/updateItem",
      deleteItem: "waterTemperatureItems/deleteItem",
      downloadItem: "waterTemperatureItems/downloadItem",
      getItem: "waterTemperatures/getItemById",
    }),

    selectCell(row, cell) {
      this.selectedCell = cell;
      this.location = row.location;
      this.scheduledDate = cell.date;
      this.selectedItemId = cell.records._id;

      if (cell.records.staffId === "") {
        this.$refs["form-dialog"].show();
      }

      if (cell.records.staffId === this.userId) {
        this.$refs["form-dialog"].show();
        this.$refs["form-dialog"].populateData(cell.records);
      }

      if (cell.records.staffId != this.userId) return;
    },

    async fetch() {
      try {
        this.isLoading = true;
        this.staffId = this.$route.params.employeeID || this.$route.params.programID;
        const response = await this.getChartItems(this.$route.query.id);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async save(data) {
      const req_body = {
        ...data,
        location: this.location,
        scheduledDate: this.scheduledDate,
        staffId: this.staffId,
        temperatureId: this.$route.query.id,
      };
      try {
        await this.createItem(req_body);
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async update(data) {
      const req_body = {
        ...data,
        location: this.location,
        scheduledDate: this.scheduledDate,
        staffId: this.staffId,
        temperatureId: this.$route.query.id,
      };
      try {
        await this.updateItem({ data: req_body, id: this.selectedItemId });
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    async generateReport() {
      this.isDownloading = true;
      try {
        const response = await this.downloadItem(this.$route.query.id);
        let pdfFile = "data:application/octet-stream;base64," + response;
        let fileName = `water-temperature-chart.pdf-${Date.now()}.pdf`;
        download(pdfFile, fileName, "application/pdf");
        this.isDownloading = false;
      } catch (e) {
        console.log(e);
        this.isDownloading = false;
      }
    },

    togglePage(page) {
      this.page = page;
    },
  },
};
</script>

<style scoped>
.tscroll {
  overflow-x: auto;
  margin-bottom: 10px;
}

.tscroll table td:first-child {
  position: sticky;
  left: 0;
}

.tscroll table,
thead,
tr,
th:first-child {
  position: sticky;
  left: 0;
}

.tscroll td,
.tscroll th {
  border-bottom: 1px dashed black;
  border-right: 1px dashed black;
}

.main-body {
  background-color: rgb(255, 255, 255);
}

.main-body--schedule {
  background-color: rgb(230, 228, 226);
}

.main-body-td--content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 7vh;
  min-width: 7vh;
}

.main-body-td--content-schedule {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 8vh;
  min-width: 12vh;
}

.table-head-th {
  border-top: 1px dashed black;
  background-color: rgb(230, 228, 226);
}

.main-body--info {
  transition: 0.3s;
}

.main-body--info:hover {
  background-color: gray;
  cursor: pointer;
}

ul {
  list-style-type: "- ";
}
</style>
